<template>
  <div>
    <oil-cap
        title="ТТН"
        :buttons="[{name:'СОЗДАТЬ ТТН',route:'coming-waybill'}]"
    />
    <oil-table
        :keys="keys"
        :items="suppliers"
        :paginate='count'
        @paginateAction='paginate'
        :rowClick="rowClick"
    >
      <template v-slot:Status="{value}">
        <v-chip color="success" v-text="value"/>
      </template>
      <template v-slot:Id="{value}">
        <v-btn icon>
          <v-icon color="primary" v-text="'mdi-pen'"/>
        </v-btn>
      </template>
    </oil-table>
  </div>
</template>

<script>
import {coreApi} from "~/services/core";

export default {
  components: {
    OilCap: () => import('@/components/helper/oil.cap'),
    OilTable: () => import('@/components/helper/oil.table'),
  },
  data: () => ({
    keys: [
      {
        text: 'ПОСТАВЩИК',
        value: 'Supplier'
      },
      {
        text: 'Номер',
        value: 'Number'
      },
      {
        text: 'Товар',
        value: 'ProductName'
      },
      {
        text: 'Количество',
        value: 'QuantityTons'
      }
    ],
    suppliers: [],
    count:{
      count:0
    }
  }),
  async created() {
    await this.paginate((this.currentPage - 1) * 10)

    // const waybill = await coreApi.get('coming-waybill')
    // this.suppliers = waybill.data?.map(waybill => {
    //   return {
    //     Id: waybill?.Id,
    //     Supplier: waybill?.Supplier?.Name,
    //     Number: waybill?.Number,
    //     ProductName: waybill?.Product?.Name,
    //     QuantityTons: waybill?.ProductInTons,
    //   }
    // }) || []

  },
  methods: {
    rowClick({Id}) {
      this.$router.push({
        name: 'coming-waybill',
        params: {id: Id}
      })
    },
    async paginate(page) {
      const suppliers = await coreApi.get(`coming-waybill/${page}`)
      const { count, dates } = suppliers.data
      this.count.count = count
      this.suppliers = dates?.map(waybill => {
        return {
          Id: waybill?.Id,
          Supplier: waybill?.Supplier?.Name,
          Number: waybill?.Number,
          ProductName: waybill?.Product?.Name,
          QuantityTons: waybill?.ProductInTons,
        }

      })
    },
  }
}
</script>